import React, { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
} from "react-router-dom";

import { encrypt } from "./utils/encodingdecoding";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import Index from "./components/layout/Index";
import NotFound from "./components/pages/NotFound";
import Homepage from "./components/pages/homepage/Homepage";
import Membership from "./components/pages/Membership";
import ClaimNow from "./components/pages/ClaimNow";
import TransactionRewards from "./components/pages/homepage/TransactionRewards";
import ScrollToTop from "./components/common/ScrollToTop";
import RouteInvoice from "./components/pages/homepage/RouteInvoice";
import ReferBrand from "./components/pages/homepage/ReferBrand";
import ReferDistributor from "./components/pages/homepage/ReferDistributor";
import ReferRetailer from "./components/pages/homepage/ReferRetailer";
import ERPSync from "./components/pages/ERPSync";
import SignIn from "./components/pages/SignIn";
import Reward from "./components/pages/rewardsTimeline/Reward";
import TrackTimeline from "./components/pages/rewardsTimeline/TrackTimeline";
import ERPSyncActive from "./components/pages/homepage/ERPSyncActive";

const App = () => {
  const Layout = () => (
    <Index>
      <Outlet />
    </Index>
  );

  return (
    <>
      <ScrollToTop>
        <Routes>
          <Route element={<Layout />}>
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Homepage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Homepage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/membership"
              element={
                <ProtectedRoute>
                  <Membership />
                </ProtectedRoute>
              }
            />
            <Route
              path="/claim-now"
              element={
                <ProtectedRoute>
                  <ClaimNow />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-rewards"
              element={
                <ProtectedRoute>
                  <TransactionRewards />
                </ProtectedRoute>
              }
            />
            <Route
              path="/route-invoice"
              element={
                <ProtectedRoute>
                  <RouteInvoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/refer-a-brand"
              element={
                <ProtectedRoute>
                  <ReferBrand />
                </ProtectedRoute>
              }
            />
            <Route
              path="/refer-a-distributor"
              element={
                <ProtectedRoute>
                  <ReferDistributor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/refer-a-retailer"
              element={
                <ProtectedRoute>
                  <ReferRetailer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/track-timeline"
              element={
                <ProtectedRoute>
                  <TrackTimeline />
                </ProtectedRoute>
              }
            />
            <Route
              path="/erp-sync"
              element={
                <ProtectedRoute>
                  <ERPSync />
                </ProtectedRoute>
              }
            />

            <Route
              path="/erp-sync-active"
              element={
                <ProtectedRoute>
                  <ERPSyncActive />
                </ProtectedRoute>
              }
            />



            <Route
              path="/reward"
              element={
                <ProtectedRoute>
                  <Reward />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <NotFound />
                </ProtectedRoute>
              }
            />
          </Route>



      <Route path="/auth/sso-login" element={<SignIn />} />



        </Routes>

      </ScrollToTop>
    </>
  );
};

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
